import React, { useEffect, useState } from 'react'
import Layout from './components/Layout';
import Login from './components/Login/Login';
import LayoutForAdmin from './components/Layout_for_Admin';
import './i18n';
import Account from './actions/Account';
import { loginStore } from './comm_stores';
import LoginMobile from './components/Login/LoginMobile';
import { LayoutMobile } from './components/LayoutMobile';
import ApiGo from './actions/ApiGo';

const LoginStatus = () => {

  const [serverVersioin, setServerVersioin] = useState("server");
  const [storeLogin, setStoreLogin] = useState(loginStore.getState());
  loginStore.subscribe(() => { setStoreLogin(loginStore.getState()) });

  useEffect(() => {
    if (storeLogin.status !== 'denied') {
      return;
    }
    const { account, password } = Account.getUrlLoginParams();
    if (!account || !password) {
      return;
    }
    let a = new Account();
    a.login(account, password)
      .then(() => {
        console.log('自動登入成功');
      })
      .catch((err) => {
        console.error('自動登入失敗', err);
      })
  }, [storeLogin.status]);

  // 判斷自動登入狀態
  useEffect(() => {
    let a = new Account
    a.get_user_devices()
    if (a.getCurrentAccount() === "denied") return
    a.verify()
      .catch(err => { console.log("loginStatus : verify failed", err) })
    a = null
    return (() => { a = null })
  }, [storeLogin]);

  useEffect(() => {
    ApiGo.getSystemDesktopOrServer()
      .then(res => {
        if (res.type === "desktop") setServerVersioin("desktop")
        else setServerVersioin("server")
      })
      .catch(err => { console.error(err) })
  }, [])

  return (
    <div className="bg_radius">
      {
        (storeLogin.status === 'denied')
          ? Account.isMobileOrTablet() ? <LoginMobile /> : <Login />
          : (storeLogin.status !== 'doctor' && storeLogin.status !== 'superdoctor' && storeLogin.status !== 'user')
            ? <LayoutForAdmin serverVersioin={serverVersioin} />
            : Account.isMobileOrTablet() ? <LayoutMobile /> : <Layout />
      }
    </div>
  );

}
export default LoginStatus;